


document.addEventListener('DOMContentLoaded', function () {



// Add a special CSS class when the cart-icon is clicked 
document.querySelector("#cart-icon").addEventListener("click", function(){
  document.body.classList.toggle("js-show-ajax-cart");

  if (document.body.classList.contains("js-show-ajax-cart") && !document.documentElement.classList.contains("js-ajax-cart-empty")) {
    // Removed the slide-in effect code
  } else {
    // Removed the slide-in effect code
  }
});

  // Listen for the "liquid-ajax-cart:request-end" event which is fired
  // after a Shopify Cart API Ajax request is performed
  document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;

    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {

      // Check if this is a min-spend product (_bsmc property)
      let hasBsmc = false;
      let bsmcTarget = 0;
      
      // Check request body for _bsmc property
      if (requestState.requestBody) {
        let bsmcValue = null;
        if (requestState.requestBody instanceof FormData) {
          bsmcValue = requestState.requestBody.get('properties[_bsmc]');
        } else if (requestState.requestBody.properties && requestState.requestBody.properties._bsmc) {
          bsmcValue = requestState.requestBody.properties._bsmc;
        }
        if (bsmcValue) {
          hasBsmc = true;
          bsmcTarget = parseFloat(bsmcValue) || 0;
        }
      }

      // If product has min-spend requirement, check if target is reached
      if (hasBsmc && bsmcTarget > 0) {
        // Calculate total _bsmv from cart
        const cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
        if (cart && cart.items) {
          let totalBsmv = 0;
          cart.items.forEach(item => {
            if (item.properties && item.properties._bsmv) {
              const itemBsmv = parseFloat(item.properties._bsmv) || 0;
              totalBsmv += itemBsmv * item.quantity;
            }
          });
          
          // Only open cart if target is reached
          if (totalBsmv >= bsmcTarget) {
            document.body.classList.add('js-show-ajax-cart');
          }
          // Don't open cart if target not reached
        } else {
          // Fallback: don't open cart for min-spend products if we can't check
        }
      } else {
        // No min-spend requirement, open cart normally
        document.body.classList.add('js-show-ajax-cart');
      }


    }
  });

});

// Close cart when clicking on the overlay
function closeCart() {
  document.body.classList.toggle("js-show-ajax-cart");
}



// PRODUCT ITEM 

document.addEventListener("DOMContentLoaded", function () {
  const colorContainer = document.querySelector(".color_container");
  const productItems = document.querySelectorAll(".Product-item");

  if (colorContainer) {
    const colorLinks = colorContainer.querySelectorAll(".color_link");
    const activeColor = colorContainer.querySelector(".active_color");
    const activeColorName = activeColor ? activeColor.querySelector(".color_name") : null;

    if (activeColorName) {
      colorLinks.forEach(link => {
        if (link !== activeColor) {
          link.addEventListener("mouseenter", () => {
            activeColorName.classList.add("hidden");
          }); 

          link.addEventListener("mouseleave", () => {
            activeColorName.classList.remove("hidden");
          });
        }
      });
    }
  }

  if (productItems.length > 0) {
    productItems.forEach(item => {
      const colorLinks = item.querySelectorAll(".color_link");
      const activeColorItem = item.querySelector(".active_color");
      const activeColorNameItem = activeColorItem ? activeColorItem.querySelector(".color_name") : null;

      colorLinks.forEach(link => {
        const linkColorName = link.querySelector(".color_name");

        link.addEventListener("mouseenter", () => {
          if (activeColorNameItem) {
            activeColorNameItem.classList.add("hidden");
          }

          if (link !== activeColorItem) {
            linkColorName.classList.remove("hidden");
          }
        });

        link.addEventListener("mouseleave", () => {
          if (activeColorNameItem) {
            activeColorNameItem.classList.remove("hidden");
          }

          if (link !== activeColorItem) {
            linkColorName.classList.add("hidden");
          }
        });
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById("terms-modal");
  const acceptButton = document.getElementById("accept-terms");
  const minSpendPopup = document.getElementById("min-spend-popup");
  const declineButton = document.getElementById("decline_checkout");
  const shopMoreButton = document.getElementById("shop_more");

  //  Simple min spend checker
  function hasRemainingSpend() {
    const progressText = document.querySelectorAll('.text-xs.text-left.mt-1, .text-sm');
    for (let el of progressText) {
      if (el.textContent.includes('mere for at aktivere rabat')) {
        return true;
      }
    }
    const progressBar = document.querySelector('.liquid-progress.liquid-yellow');
    return !!progressBar;
  }

  //  Checkout click handler (same structure as your original)
  document.body.addEventListener('click', function (event) {
    const target = event.target;
    const nameAttr = target.getAttribute('name');

    if (nameAttr === 'checkout' || nameAttr === 'goto_pp' || nameAttr === 'goto_gc') {
      const agreeCheckbox = document.getElementById('agree');

      // 🔸 FIRST: Min spend check
      if (hasRemainingSpend()) {
        if (minSpendPopup) minSpendPopup.style.display = 'block';
        event.preventDefault();
        return;
      }

      // 🔸 THEN: Terms check
      if (agreeCheckbox.checked) {
        if (target.form) {
          target.form.submit();
        } else {
          window.location.href = '/checkout';
        }
      } else {
        modal.style.display = "block";
        event.preventDefault();
      }
    }
  });

  //  Accept terms → go to checkout
  acceptButton.onclick = function () {
    modal.style.display = "none";
    const agreeCheckbox = document.getElementById('agree');
    agreeCheckbox.checked = true;
    window.location.href = '/checkout';
  };

  //  Close modals on background click
  window.onclick = function (event) {
    if (event.target === modal) {
      modal.style.display = "none";
    }
    if (event.target === minSpendPopup) {
      minSpendPopup.style.display = "none";
    }
  };

  //  Decline checkout in min spend popup → fallback to terms check
  if (declineButton) {
    declineButton.addEventListener('click', function (event) {
      event.preventDefault();
      minSpendPopup.style.display = 'none'; 
      const agreeCheckbox = document.getElementById('agree');

      if (agreeCheckbox.checked) {
        window.location.href = '/checkout';
      } else {
        modal.style.display = "block";
      }
    });
  }

  // Shop more button
  if (shopMoreButton) {
    shopMoreButton.addEventListener('click', function (event) {
      event.preventDefault();
      minSpendPopup.style.display = 'none';
      window.location.href = '/collections/all'; // Or change this link if needed
    });
  }
});


// cart instructions dropdown
function toggleCartInstructions() {
  var dropdown = document.getElementById('cartInstructionDropdown');
  var arrow = document.getElementById('arrow');
  if (dropdown.classList.contains('hidden')) {
      dropdown.classList.remove('hidden');
      arrow.classList.remove('arrow-down');
      arrow.classList.add('arrow-up');
  } else {
      dropdown.classList.add('hidden');
      arrow.classList.remove('arrow-up');
      arrow.classList.add('arrow-down');
  }
}


// Faq product 

document.addEventListener("DOMContentLoaded", function() {
  const questions = document.querySelectorAll('.accordion_product .question');

  questions.forEach((question) => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const icon = question.querySelector('.acc-icon');
      
      if (answer.classList.contains('hidden')) {
        answer.classList.remove('hidden');
        icon.classList.add('rotated');
      } else {
        answer.classList.add('hidden');
        icon.classList.remove('rotated');
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function() {
  let faqSections = document.querySelectorAll(".faq-section");


  if (faqSections.length > 0) {
    let accordions = document.querySelectorAll(".faq-section .accordion");
  
    accordions.forEach((accordion) => {
      accordion.addEventListener("click", function(e) {
        e.preventDefault();
        this.classList.toggle("active");
        let content = this.nextElementSibling;
        if (content.style.display === "block") {
          content.style.display = "none";
        } else {
          content.style.display = "block";
        }
      });
    });
  }
});

/* Product Card Color Swatch AJAX */
document.addEventListener('click', function(e) {
  const swatchLink = e.target.closest('.js-color-swatch-link');
  if (!swatchLink) return;
  e.preventDefault();
  const handle = swatchLink.getAttribute('data-product-handle');
  if (!handle) return;
  const card = swatchLink.closest('.product_card'); 
  if (!card) return;
  
  // Instant Page / Prefetch logic
  const prefetchUrl = swatchLink.href;
  if (prefetchUrl && !document.querySelector(`link[rel="prefetch"][href="${prefetchUrl}"]`)) {
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = prefetchUrl;
    document.head.appendChild(link);
  }

  card.style.opacity = '0.7';
  card.style.pointerEvents = 'none';
  
  fetch(`/products/${handle}?section_id=api-card-product`)
    .then(r => r.text())
    .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        // Retrieve the top-level element from the response (which might be the section div wrapping the card)
        // Adjust depending on how section API returns: often a Shopify section output wraps the liquid
        // But since we use render 'card-product', checking if the response wrapper contains .product_card
        const newCard = doc.querySelector('.product_card');
        
        if (newCard && card.parentNode) {
            const parent = card.parentNode;
            card.replaceWith(newCard);
            
            // Re-init Splide
            if (typeof Splide !== 'undefined') {
                 newCard.querySelectorAll('.splide.js-product-card-slider').forEach(el => {
                     try {
                        new Splide(el, {"pagination":false, "arrows":true, "drag":true}).mount();
                     } catch(err) { console.warn(err); }
                 });
            }

            // Re-bind hover events for 'color_link' inside the new card (copied from main.js logic)
            // Color name display logic
            const colorContainer = document.querySelector(".color_container"); // This is global? If so, not relevant to card replacement
            // BUT: productItems logic in main.js
            const item = newCard.closest('.Product-item') || newCard.querySelector('.Product-item') || newCard;
            if (item) {
                 const colorLinks = item.querySelectorAll(".color_link");
                 const activeColorItem = item.querySelector(".active_color");
                 const activeColorNameItem = activeColorItem ? activeColorItem.querySelector(".color_name") : null;

                 colorLinks.forEach(link => {
                    const linkColorName = link.querySelector(".color_name");
                    // Ensure we don't double-bind if reusing logic, but these are new elements
                    link.addEventListener("mouseenter", () => {
                      if (activeColorNameItem) activeColorNameItem.classList.add("hidden");
                      if (link !== activeColorItem && linkColorName) linkColorName.classList.remove("hidden");
                    });
                    link.addEventListener("mouseleave", () => {
                      if (activeColorNameItem) activeColorNameItem.classList.remove("hidden");
                      if (link !== activeColorItem && linkColorName) linkColorName.classList.add("hidden");
                    });
                 });
            }
        
        } else {
             window.location.href = swatchLink.href;
        }
    })
    .catch(e => {
        console.error(e);
        window.location.href = swatchLink.href;
    });
});

/* Show more colors in product card */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.js-show-more-colors');
  if (!btn) return;
  
  e.preventDefault();
  e.stopPropagation();
  
  const container = btn.closest('.color_list');
  if (!container) return;
  
  const hiddenColors = container.querySelectorAll('.js-extra-color');
  hiddenColors.forEach(el => el.classList.remove('hidden'));
  
  btn.classList.add('hidden');
});
